import { useEventStore } from "@/event";
import { EventUpgradeIds } from "@/game/entities/config/upgrades/";
import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import useTileRepository from "@/hooks/useTileRepository";
import useUpgradesStore from "@/store/useUpgradesStore";
import { EventCategory } from "@/types/ui";

/** Offline income multiplier from active seasonal foreman upgrades (fallback = global offline %). */
export function eventOfflineIncomeMultiplier(): number {
	const fallback = useTileRepository().offlinePercentage();
	const type = useEventStore().attributes.type;

	switch (type) {
		case EventCategory.CHRISTMAS: {
			const id = EventUpgradeIds.ch_foreman;
			return useUpgradesStore().getCurrentLevelById(id) > 0
				? getUpgradeCurrentReplaceValueById(id)
				: fallback;
		}
		case EventCategory.EASTER: {
			const id = EventUpgradeIds.ea_foreman;
			return useUpgradesStore().getCurrentLevelById(id) > 0
				? getUpgradeCurrentReplaceValueById(id)
				: fallback;
		}
		case EventCategory.FISHING: {
			const id = EventUpgradeIds.fi_foreman;
			return useUpgradesStore().getCurrentLevelById(id) > 0
				? getUpgradeCurrentReplaceValueById(id)
				: fallback;
		}
		case EventCategory.FIREFEST: {
			const id = EventUpgradeIds.ff_foreman;
			return useUpgradesStore().getCurrentLevelById(id) > 0
				? getUpgradeCurrentReplaceValueById(id)
				: fallback;
		}
		case EventCategory.SOLAR: {
			const id = EventUpgradeIds.sf_peddler;
			return useUpgradesStore().getCurrentLevelById(id) > 0
				? getUpgradeCurrentReplaceValueById(id)
				: fallback;
		}
		case EventCategory.HUNTING: {
			const id = EventUpgradeIds.hu_foreman;
			return useUpgradesStore().getCurrentLevelById(id) > 0
				? getUpgradeCurrentReplaceValueById(id)
				: fallback;
		}
		case EventCategory.HALLOWEEN: {
			const id = EventUpgradeIds.ha_foreman;
			return useUpgradesStore().getCurrentLevelById(id) > 0
				? getUpgradeCurrentReplaceValueById(id)
				: fallback;
		}
		case EventCategory.PIRATES: {
			const id = EventUpgradeIds.pi_foreman;
			return useUpgradesStore().getCurrentLevelById(id) > 0
				? getUpgradeCurrentReplaceValueById(id)
				: fallback;
		}
		default:
			return fallback;
	}
}
